module.exports = "../images/icons/Btn-plane.svg";